import React from "react";
import Layout from "../../components/layout";
import HeroSection from "./HeroSection";
import MiddleSection from "./MiddleSection";
import ContactSection from "./ContactSection";
import CtaSectionAction from "../../components/shared-components/CtaSectionAction";
import styled from "styled-components";

const CtaSectionWrapper = styled.div`
  margin: 40px;
`;

const Contact = () => {
  return (
    <Layout fullScreen>
      <HeroSection />
      <MiddleSection />
      <ContactSection />
      <CtaSectionWrapper>
        <CtaSectionAction />
      </CtaSectionWrapper>
    </Layout>
  );
};

export default Contact;
